module.exports = __webpack_public_path__ + "static/media/gray_11.1.6dfa62fb.jpg";